import { Box } from "@mui/material";
import { PublicMenu, PublicFooter } from "../components/public";

type AccountLayoutProps = {
  children: React.ReactNode;
};

export const AccountLayout = ({ children }: AccountLayoutProps) => {
  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <PublicMenu />
      <Box component="main" flexGrow={1}>
        {children}
      </Box>
      <PublicFooter />
    </Box>
  );
};
